import { Component, Input } from "@angular/core";
import { GameType, MagicCard, MagicCardFace } from "@apiserver-rest/ponder-data-client-base";
import { MagicSetIconComponent } from "../set/magic-set-icon.component";
import { MagicCardManaCostComponent } from "./magic-card-mana-cost.component";
import { formatDate } from "@ponder-shared/utils/general";
import { MagicMarkdownPipe } from "../markdown/magic-markdown.pipe";

@Component({
    selector: "magic-card-face-text",
    imports: [MagicSetIconComponent, MagicCardManaCostComponent, MagicMarkdownPipe],
    templateUrl: "./magic-card-face-text.component.html"
})
export class MagicCardFaceTextComponent {
    @Input({ required: true }) public magicCard!: MagicCard;
    @Input({ required: true }) public magicCardFace!: MagicCardFace;
    @Input({ required: true }) public isBackface: boolean = false;
    @Input() public isTranslation: boolean = false;

    constructor() {

    }

    public getName(forceEnglish: boolean): string | undefined {
        if (this.magicCardFace.localizedName && !forceEnglish) {
            return this.magicCardFace.localizedName;
        }

        return this.magicCardFace.name;
    }

    public hasFlavorName(): boolean {
        if (this.magicCardFace.flavorName) {
            return true;
        }

        return false;
    }

    public getFlavorName(): string | undefined {
        return this.magicCardFace.flavorName;
    }

    public hasManaCost(): boolean {
        if (this.magicCardFace.manaCost) {
            return true;
        }

        return false;
    }

    public getManaCost(): string | undefined {
        return this.magicCardFace.manaCost;
    }

    public getTypeLine(forceEnglish: boolean): string | undefined {
        if (this.magicCardFace.localizedTypeLine && !forceEnglish) {
            return this.magicCardFace.localizedTypeLine;
        }
        
        return this.magicCardFace.typeLine;
    }
    
    public getText(forceEnglish: boolean): string | undefined {
        if (this.magicCardFace.localizedText && !forceEnglish) {
            return this.magicCardFace.localizedText;
        }

        return this.magicCardFace.oracleText;
    }

    public getFlavorText(): string | undefined {
        return this.magicCardFace.flavorText;
    }

    public hasPowerToughness(): boolean {
        if (this.magicCardFace.power) {
            return true;
        }

        return false;
    }

    public getPowerToughness(): string | undefined {
        var power = this.magicCardFace.power;
        var toughness = this.magicCardFace.toughness;

        if (!power || !toughness) {
            return "";
        } else {
            if (power === "*") {
                power = "★";
            }

            if (toughness === "*") {
                toughness = "★";
            }

            return `${power} / ${toughness}`;
        }
    }

    public getArtistName(): string | undefined {
        return this.magicCardFace.artist?.name;
    }

    public getArtistRoute(): string {
        return `/search?game=Magic&artist=${this.magicCardFace.artist!.name}`;
    }

    public getReleaseDateStr(): string | undefined {
        if (this.magicCard.releaseDate! > new Date()) {
            return `Releasing on ${formatDate(this.magicCard.releaseDate)}`;
        } else {
            return `Released on ${formatDate(this.magicCard.releaseDate)}`;
        }
    }

    public getSetName(): string | undefined {
        return this.magicCard.set.name;
    }
}